/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Fleet_AutoInputs */

const en_dispatch_fleet_auto = /** @type {(inputs: Dispatch_Fleet_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— Auto (RMF picks) —`)
};

const fr_dispatch_fleet_auto = /** @type {(inputs: Dispatch_Fleet_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— Auto (RMF choisit) —`)
};

const ms_sg2_dispatch_fleet_auto = /** @type {(inputs: Dispatch_Fleet_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— Auto (RMF memilih) —`)
};

/**
* | output |
* | --- |
* | "— Auto (RMF picks) —" |
*
* @param {Dispatch_Fleet_AutoInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_fleet_auto = /** @type {((inputs?: Dispatch_Fleet_AutoInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Fleet_AutoInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_fleet_auto(inputs)
	if (locale === "fr") return fr_dispatch_fleet_auto(inputs)
	return ms_sg2_dispatch_fleet_auto(inputs)
});